import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import useSearchParams from 'modules/core/hooks/useSearchParams'

import SaleInvoicesUpsertSidePanel from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SaleInvoiceUpsertPage = ({ backPage }: { backPage: string }) => {
  const navigate = useNavigate()
  const { invoiceId } = useParams()
  const { employee } = useCurrentSession()
  const { createCreditNote } = useSearchParams<{
    createCreditNote?: boolean
  }>()

  const defaultLegalEntity = employee?.legalEntity
  const defaultCurrency = defaultLegalEntity?.currency

  const onClose = () => {
    if (invoiceId) {
      navigate(backPage.replace('-1', invoiceId))
    } else {
      navigate(backPage)
    }
  }

  return (
    <ResponsivePage.Body variant="full">
      <SaleInvoicesUpsertSidePanel
        invoiceId={invoiceId}
        onClose={onClose}
        defaultCurrency={defaultCurrency}
        defaultLegalEntity={defaultLegalEntity}
        createCreditNoteProp={createCreditNote}
      />
    </ResponsivePage.Body>
  )
}

export default SaleInvoiceUpsertPage
